<div class="cloud-bacnet">
    <div class="cloud-bacnet__toolbar">
        <p-button icon="fa fa-refresh" [text]="true" severity="info" size="small" ariaLabel="Refresh BACnet status" pTooltip="Refresh BACnet status" [loading]="loading()" (onClick)="load()"></p-button>
    </div>

    @if (error()) {
        <p-message severity="error" class="w-full">{{ error() }}</p-message>
    }

    @if (loading() && !status()) {
        <app-loading-skeleton preset="detail" label="Loading BACnet status" />
    }

    @if (status(); as info) {
        <app-section-card title="BACnet Status" icon="fa fa-network-wired">
            <div class="cloud-bacnet__tags">
                <p-tag [severity]="info.supported ? 'success' : 'danger'" [value]="info.supported ? 'Supported' : 'Not supported'" />
                <p-tag [severity]="info.licensed ? 'success' : 'warn'" [value]="info.licensed ? 'Licensed' : 'Not licensed'" />
                <p-tag [severity]="info.registered ? 'success' : 'secondary'" [value]="info.registered ? 'Registered' : 'Not registered'" />
            </div>

            <dl class="app-facts">
                <div class="app-fact">
                    <dt>BACnet version</dt>
                    <dd>{{ info.bacnetVersion || '—' }}</dd>
                </div>
                <div class="app-fact">
                    <dt>Device instance</dt>
                    <dd>{{ info.deviceInstanceId ?? '—' }}</dd>
                </div>
                <div class="app-fact">
                    <dt>Port</dt>
                    <dd>{{ info.portNumber ?? '—' }}</dd>
                </div>
                <div class="app-fact">
                    <dt>Endpoints used</dt>
                    <dd>{{ endpointsLabel() }}</dd>
                </div>
                <div class="app-fact">
                    <dt>Discovery</dt>
                    <dd>{{ info.discoveryEnabled ? 'Enabled' : 'Disabled' }}</dd>
                </div>
                @if (discoveryStatus()) {
                    <div class="app-fact">
                        <dt>Discovery status</dt>
                        <dd>{{ discoveryStatus() }}</dd>
                    </div>
                }
            </dl>

            @if (!info.licensed) {
                <p-message severity="info" class="w-full mt-3"> BACnet is not licensed on this processor. Licensing is done from the dashboard running on the processor, which shows the System Key and Hostname needed to claim a licence. </p-message>
            }
        </app-section-card>

        <app-section-card title="Exposed objects" subtitle="BACnet objects this control program publishes" icon="fa fa-list" [count]="objects().length || null" [flush]="true">
            @if (objects().length) {
                <p-table [value]="objects()" [paginator]="objects().length > 10" [rows]="10" [rowHover]="true">
                    <ng-template #header>
                        <tr>
                            <th>Type</th>
                            <th>Instance</th>
                            <th>Name</th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-object>
                        <tr>
                            <td>{{ object.objectType }}</td>
                            <td>{{ object.instanceId }}</td>
                            <td>{{ object.name || '—' }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            } @else {
                <app-empty-state icon="fa fa-list" title="No BACnet objects" description="This control program does not expose any BACnet objects." [compact]="true" />
            }
        </app-section-card>

        <app-section-card title="Discovered devices" subtitle="What the last discovery on the processor found" icon="fa fa-radar" [count]="discoveredDevices().length || null" [flush]="true">
            @if (discoveredDevices().length) {
                <p-table [value]="discoveredDevices()" [paginator]="discoveredDevices().length > 10" [rows]="10" [rowHover]="true">
                    <ng-template #header>
                        <tr>
                            <th>Device ID</th>
                            <th>IP address</th>
                            <th>Network</th>
                            <th>Vendor</th>
                            <th>Objects</th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-device>
                        <tr>
                            <td>{{ device.deviceId }}</td>
                            <td>{{ device.ipAddress || '—' }}</td>
                            <td>{{ device.networkNumber ?? '—' }}</td>
                            <td>{{ device.vendorName || device.vendorId || '—' }}</td>
                            <td>{{ device.numberOfDiscoveredObjects }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            } @else {
                <app-empty-state icon="fa fa-radar" title="No devices discovered" description="Discovery runs from the dashboard on the processor. Whatever the last run found is shown here." [compact]="true" />
            }
        </app-section-card>
    }
</div>
